import { useEffect, useState } from "react";
import { useAuth } from "components/ui/NavigationGuard";
import yoloApi from "services/api/yoloApi";

const PPE_CLASSES = [
  "Gloves",
  "Hardhat",
  "Safety-Vest",
  "Boots"
];

const NO_CLASSES = [
  "No-Gloves",
  "No-Hardhat",
  "No-Safety-Vest",
  "No-Boots"
];

const useYolo = () => {
  const { user } = useAuth();
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);
  const [detectionMode, setDetectionMode] = useState("PERSON");

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const data = await yoloApi.getSettings();
      setSettings(data);

      // auto detect current mode
      const fullKitEnabled = data.find(i => i.class_name === "full-kit")?.enabled;
      setDetectionMode(fullKitEnabled ? "FULL_KIT" : "PERSON");

    } catch (err) {
      setError("Failed to load YOLO settings");
    } finally {
      setLoading(false);
    }
  };

  const applyMode = async () => {
    try {
      setLoading(true);
      setError(null);

      for (const item of settings) {
        let enabled = false;

        if (detectionMode === "FULL_KIT") {
          if (
            item.class_name === "full-kit" ||
            item.class_name === "Person" ||
            PPE_CLASSES.includes(item.class_name)
          ) {
            enabled = true;
          }
        }

        if (detectionMode === "PERSON") {
          if (item.class_name === "Person") {
            enabled = true;
          }
        }

        // No-* always false
        if (NO_CLASSES.includes(item.class_name)) {
          enabled = false;
        }

        // ?? Call existing single-update API
        await yoloApi.updateSetting(item.id, {
          enabled
        });
      }

      await fetchSettings();

    } catch (err) {
      console.error(err);
      setError("Failed to apply detection mode");
    } finally {
      setLoading(false);
    }
  };


  return {
    user,
    loading,
    error,
    isNavCollapsed,
    setIsNavCollapsed,
    detectionMode,
    setDetectionMode,
    applyMode
  };
};

export default useYolo;